import tools from './tools';

// Bootstrap color names
const colorNames = ['blue', 'indigo', 'purple', 'pink', 'red', 'orange', 'yellow', 'green', 'teal', 'cyan', 'gray'];

// ColorInput component
export default function (states = {}) {
    let root, input, preview, instance;
    let instantiated = false;

    return {
        get value() {
            return input._x_model ? input._x_model.get() : instance ? instance.getColor().toHEXA().toString() : input.value;
        },

        set value(value) {
            input._x_model ? input._x_model.set(value) : instance ? instance.setColor(value) : (input.value = value);
        },

        instance() {
            return instance;
        },

        init() {
            root = this.$root;
            input = this.$refs.input;
            preview = this.$refs.preview;

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                instance.destroyAndRemove();
            } catch (error) {}
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            instance = Pickr.create({
                el: this.$refs.picker,
                container: this.isInModal ? root.closest('.modal-body') : document.body,
                theme: 'classic',
                useAsButton: true,
                defaultRepresentation: 'HEX',

                swatches: colorNames.map((name) => Helper.cssVar('--' + (IS_BOOTSTRAP5 ? 'bs-' : '') + name)),

                components: {
                    preview: true,
                    opacity: states.opacitySlider,
                    hue: true,
                },
            });

            instance.on('show', (instance) => {
                if (this.events) {
                    this.events['x-on:focusin']({
                        type: 'focusin',
                        target: { name: tools.getName(root) },
                    });
                }
            });

            instance.on('hide', (instance) => {
                if (this.events) {
                    this.events['x-on:focusout']({
                        type: 'focusout',
                        target: { name: tools.getName(root) },
                    });
                }

                input.dispatchEvent(new Event('change'));
            });

            const updateColor = (color) => {
                const value = color.toHEXA().toString();

                input.value = value;
                preview.style.backgroundColor = value;

                if (input._x_model) {
                    input._x_model.set(value);
                }
            };

            instance.on('change', (color, instance) => updateColor(color));
            instance.on('cancel', (instance) => updateColor(instance.getSelectedColor()));

            this.$nextTick(() => {
                if (input._x_model) {
                    this.$watch(tools.getXModelValue(input), (value, oldValue) => {
                        if (value.toLowerCase() === oldValue.toLowerCase()) return;

                        instance.setColor(value);
                    });
                }

                instance.setColor(input.value);
                preview.style.backgroundColor = input.value;
            });
        },

        input() {
            instance.setColor(input.value);
        },
    };
}
